let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7ogxc")).then(() => parcelRequire('8OCzv'));